import { ScopeItem } from './ScopeItem'

interface Scope {
  name: string
  description: string
}

interface ScopeListProps {
  scopes: Scope[]
  newScopes: string[]
  title?: string
}

export function ScopeList({ scopes, newScopes, title }: ScopeListProps) {
  if (scopes.length === 0) return null

  return (
    <div>
      {title && (
        <h3 className="mb-2 text-sm font-medium text-[var(--text-secondary)]">
          {title}
        </h3>
      )}
      <div className="space-y-1">
        {scopes.map((scope) => (
          <ScopeItem
            key={scope.name}
            name={scope.name}
            description={scope.description}
            isNew={newScopes.includes(scope.name)}
          />
        ))}
      </div>
    </div>
  )
}
